const cdnUrl = process.env.GATSBY_CDN_URL;

const getBackgroundImageStyles = (backgroundImageOrGradientOrColor: string) => {
  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];
  if (
    backgroundImageOrGradientOrColor &&
    imageExtensions.some((ext) => backgroundImageOrGradientOrColor.toLowerCase().endsWith(ext))
  ) {
    return `url('${cdnUrl}${backgroundImageOrGradientOrColor}')`;
  }
  return backgroundImageOrGradientOrColor;
};

export default getBackgroundImageStyles;
